import { useCountryCode } from './useCurrencyDetails';
export const useRussianBlockedBanner = () => {
  const countryCode = useCountryCode();
  const shouldShowRussianBlockedBanner = countryCode === 'RU';
  return shouldShowRussianBlockedBanner;
};